import * as React from "react"
import { SVGProps } from "react"
const BuildOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill={props.fill}
      d="M10.984.016c1.563.156 3 .656 4.313 1.5a9.712 9.712 0 0 1 3.187 3.187 9.215 9.215 0 0 1 1.453 4.313 9.584 9.584 0 0 1-.843 5.109c-.719 1.594-1.797 2.922-3.235 3.984-1.437 1.032-3.062 1.641-4.875 1.828v-2.015c1.813-.219 3.36-.969 4.641-2.25 1.313-1.313 2.094-2.875 2.344-4.688a8.084 8.084 0 0 0-.61-4.125 7.345 7.345 0 0 0-2.53-3.234 7.788 7.788 0 0 0-3.845-1.594V.016ZM9.016.062v2.016a7.887 7.887 0 0 0-3.938 1.64L3.672 2.267C5.203.984 6.984.25 9.016.062Zm-6.75 3.61 1.406 1.406a8.49 8.49 0 0 0-1.64 3.938H.061C.25 6.984.985 5.203 2.267 3.672ZM.062 10.984h2.016c.156 1.438.688 2.75 1.594 3.938l-1.406 1.406a9.675 9.675 0 0 1-2.204-5.344Zm5.016 5.391c1.188.906 2.5 1.453 3.938 1.64v1.97a9.969 9.969 0 0 1-5.344-2.25l1.406-1.36Zm9.75-3.188c.094.063.125.172.094.329a.45.45 0 0 1-.14.328l-1.032 1.031a.45.45 0 0 1-.328.14.45.45 0 0 1-.328-.14L9.016 10.75a2.683 2.683 0 0 1-1.641.14 3.02 3.02 0 0 1-1.5-.843A3.03 3.03 0 0 1 5.031 8.5c-.093-.625 0-1.219.282-1.781L7.28 8.687l1.36-1.359L6.67 5.36a2.889 2.889 0 0 1 1.782-.187c.625.094 1.14.36 1.547.797.438.406.719.906.844 1.5a2.517 2.517 0 0 1-.14 1.593l4.124 4.126Z"
    />
  </svg>
)
export default BuildOutlined
